import { Box } from '@mui/material';

const DarkBackground = ({ children }) => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        width: '100%',
        background: '#FF8533', // Dark orange from gradient
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(255, 255, 255, 0.1)', // Subtle overlay for depth
          pointerEvents: 'none'
        }
      }}
    >
      {children}
    </Box>
  );
};

export default DarkBackground; 